"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findConflicts = findConflicts;
exports.formattedTooltipDate = exports.formatMessageDate = void 0;
exports.getAppointmentOffset = getAppointmentOffset;
exports.getAppointmentWidth = getAppointmentWidth;
exports.getCurrentWeek = getCurrentWeek;
exports.isNewMonth = isNewMonth;
exports.isOverlapping = isOverlapping;
var _facades = require("../facades");
function getCurrentWeek() {
  return (0, _facades.startOfWeek)(new Date());
}
function isNewMonth(week) {
  var thisMonday = (0, _facades.startOfWeek)(week);
  var lastMonday = (0, _facades.subWeeks)(thisMonday, 1);
  return !(0, _facades.isSameMonth)(thisMonday, lastMonday);
}
function isOverlapping(firstRange, secondRange) {
  return (0, _facades.areIntervalsOverlapping)(firstRange, secondRange, {
    inclusive: true
  });
}
function getAppointmentWidth(from, to, dayWidth) {
  var margins = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var startOfCalendar = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : from;
  var endOfCalendar = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : to;
  var daysBetween = (0, _facades.differenceInDays)((0, _facades.min)([to, endOfCalendar]), (0, _facades.max)([from, startOfCalendar]));
  return (daysBetween + 1) * dayWidth - margins;
}
function getAppointmentOffset(startOfCalendar, startOfAppointment, dayWidth) {
  var daysFromStartWeek = (0, _facades.differenceInDays)(startOfAppointment, startOfCalendar);
  if (daysFromStartWeek < 0) return 0;
  return daysFromStartWeek * dayWidth;
}
function findConflicts(from, to, termine) {
  var newTerminRange = {
    start: from,
    end: to
  };
  return termine.filter(function (item) {
    var itemRange = {
      start: item.from,
      end: item.to
    };
    return (0, _facades.areIntervalsOverlapping)(newTerminRange, itemRange, {
      inclusive: true
    });
  });
}
var formatMessageDate = exports.formatMessageDate = function formatMessageDate(date) {
  return (0, _facades.format)(date, 'dd.MM HH:mm');
};
var formattedTooltipDate = exports.formattedTooltipDate = function formattedTooltipDate(from, to) {
  var toolTipDate = (0, _facades.format)(from, 'eeeeee, dd.MM.yy');
  if ((0, _facades.differenceInDays)(to, from) > 0) toolTipDate += " - ".concat((0, _facades.format)(to, 'eeeeee, dd.MM.yy'));
  return toolTipDate;
};